/** CoStar.Api.AptsFeedManagement.ViewModels.FeedControlStatus */
export var FeedControlStatus;
(function (FeedControlStatus) {
    FeedControlStatus[FeedControlStatus["None"] = 0] = "None";
    FeedControlStatus[FeedControlStatus["Created"] = 10] = "Created";
    FeedControlStatus[FeedControlStatus["RetrievalProcessing"] = 20] = "RetrievalProcessing";
    FeedControlStatus[FeedControlStatus["RetrievalFailed"] = 30] = "RetrievalFailed";
    FeedControlStatus[FeedControlStatus["FileNotFound"] = 35] = "FileNotFound";
    FeedControlStatus[FeedControlStatus["RetrievalSuccess"] = 40] = "RetrievalSuccess";
    FeedControlStatus[FeedControlStatus["FileNotFoundInWorkingDirectory"] = 45] = "FileNotFoundInWorkingDirectory";
    FeedControlStatus[FeedControlStatus["ValidationProcessing"] = 50] = "ValidationProcessing";
    FeedControlStatus[FeedControlStatus["ValidationFailed"] = 60] = "ValidationFailed";
    FeedControlStatus[FeedControlStatus["ValidationSuccess"] = 70] = "ValidationSuccess";
    FeedControlStatus[FeedControlStatus["DataCleanseProcessing"] = 80] = "DataCleanseProcessing";
    FeedControlStatus[FeedControlStatus["DataCleanseFailed"] = 90] = "DataCleanseFailed";
    FeedControlStatus[FeedControlStatus["DataCleanseSuccess"] = 100] = "DataCleanseSuccess";
    FeedControlStatus[FeedControlStatus["TransformationProcessing"] = 110] = "TransformationProcessing";
    FeedControlStatus[FeedControlStatus["TransformationFailed"] = 120] = "TransformationFailed";
    FeedControlStatus[FeedControlStatus["TransformationSuccess"] = 130] = "TransformationSuccess";
    FeedControlStatus[FeedControlStatus["DataLoaderReadyToProcess"] = 140] = "DataLoaderReadyToProcess";
    FeedControlStatus[FeedControlStatus["DataLoaderProcessing"] = 150] = "DataLoaderProcessing";
    FeedControlStatus[FeedControlStatus["DataLoaderFailed"] = 160] = "DataLoaderFailed";
    FeedControlStatus[FeedControlStatus["DataLoaderSuccess"] = 170] = "DataLoaderSuccess";
    FeedControlStatus[FeedControlStatus["ProviderNotificationProcessing"] = 180] = "ProviderNotificationProcessing";
    FeedControlStatus[FeedControlStatus["ProviderNotificationFailed"] = 190] = "ProviderNotificationFailed";
    FeedControlStatus[FeedControlStatus["ProviderNotificationSuccess"] = 200] = "ProviderNotificationSuccess";
    FeedControlStatus[FeedControlStatus["Complete"] = 210] = "Complete";
    FeedControlStatus[FeedControlStatus["Archive"] = 220] = "Archive";
    FeedControlStatus[FeedControlStatus["FeedAuthorizationProcessing"] = 230] = "FeedAuthorizationProcessing";
    FeedControlStatus[FeedControlStatus["FeedAuthorizationFailed"] = 240] = "FeedAuthorizationFailed";
    FeedControlStatus[FeedControlStatus["FeedAuthorizationSuccess"] = 250] = "FeedAuthorizationSuccess";
    FeedControlStatus[FeedControlStatus["MongoQueueRequest"] = 260] = "MongoQueueRequest";
    FeedControlStatus[FeedControlStatus["SafetyCheckProcessing"] = 270] = "SafetyCheckProcessing";
    FeedControlStatus[FeedControlStatus["SafetyCheckInterrupt"] = 280] = "SafetyCheckInterrupt";
    FeedControlStatus[FeedControlStatus["SafetyCheckError"] = 290] = "SafetyCheckError";
    FeedControlStatus[FeedControlStatus["SafetyCheckOverride"] = 300] = "SafetyCheckOverride";
    FeedControlStatus[FeedControlStatus["SafetyCheckSuccess"] = 310] = "SafetyCheckSuccess";
    FeedControlStatus[FeedControlStatus["DataFeedTypeInactive"] = 320] = "DataFeedTypeInactive";
    FeedControlStatus[FeedControlStatus["Error"] = 990] = "Error";
})(FeedControlStatus || (FeedControlStatus = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.ErrorCode */
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["None"] = 0] = "None";
    ErrorCode[ErrorCode["Error"] = 1] = "Error";
})(ErrorCode || (ErrorCode = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.MultiFamilyFeedProcessingLogType */
export var MultiFamilyFeedProcessingLogType;
(function (MultiFamilyFeedProcessingLogType) {
    MultiFamilyFeedProcessingLogType[MultiFamilyFeedProcessingLogType["None"] = 0] = "None";
    MultiFamilyFeedProcessingLogType[MultiFamilyFeedProcessingLogType["MatchedModel"] = 1] = "MatchedModel";
    MultiFamilyFeedProcessingLogType[MultiFamilyFeedProcessingLogType["UnmatchedModel"] = 2] = "UnmatchedModel";
    MultiFamilyFeedProcessingLogType[MultiFamilyFeedProcessingLogType["MissingModel"] = 3] = "MissingModel";
    MultiFamilyFeedProcessingLogType[MultiFamilyFeedProcessingLogType["AutoMatchModel"] = 4] = "AutoMatchModel";
    MultiFamilyFeedProcessingLogType[MultiFamilyFeedProcessingLogType["TrustModelMixViolation"] = 5] = "TrustModelMixViolation";
    MultiFamilyFeedProcessingLogType[MultiFamilyFeedProcessingLogType["TrustModelUnitCountViolation"] = 6] = "TrustModelUnitCountViolation";
})(MultiFamilyFeedProcessingLogType || (MultiFamilyFeedProcessingLogType = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.PropertyFeedOverrideType */
export var PropertyFeedOverrideType;
(function (PropertyFeedOverrideType) {
    PropertyFeedOverrideType[PropertyFeedOverrideType["NoOverride"] = 0] = "NoOverride";
    PropertyFeedOverrideType[PropertyFeedOverrideType["OverrideDataOnly"] = 1] = "OverrideDataOnly";
    PropertyFeedOverrideType[PropertyFeedOverrideType["OverrideDataAndPhotos"] = 2] = "OverrideDataAndPhotos";
})(PropertyFeedOverrideType || (PropertyFeedOverrideType = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.FeedVendorType */
export var FeedVendorType;
(function (FeedVendorType) {
    FeedVendorType[FeedVendorType["Unknown"] = 0] = "Unknown";
    FeedVendorType[FeedVendorType["MLS"] = 1] = "MLS";
    FeedVendorType[FeedVendorType["PropertyResidential"] = 2] = "PropertyResidential";
    FeedVendorType[FeedVendorType["MultiFamily"] = 3] = "MultiFamily";
})(FeedVendorType || (FeedVendorType = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.ListingAddressDuplicationCheckErrorCode */
export var ListingAddressDuplicationCheckErrorCode;
(function (ListingAddressDuplicationCheckErrorCode) {
    ListingAddressDuplicationCheckErrorCode[ListingAddressDuplicationCheckErrorCode["None"] = 0] = "None";
    ListingAddressDuplicationCheckErrorCode[ListingAddressDuplicationCheckErrorCode["HasError"] = 1] = "HasError";
})(ListingAddressDuplicationCheckErrorCode || (ListingAddressDuplicationCheckErrorCode = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.ActionType */
export var ActionType;
(function (ActionType) {
    ActionType[ActionType["TakeListingOffMarket"] = 10] = "TakeListingOffMarket";
    ActionType[ActionType["UpdateCertifiedFreshDate"] = 20] = "UpdateCertifiedFreshDate";
    ActionType[ActionType["TerminateListing"] = 30] = "TerminateListing";
})(ActionType || (ActionType = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.FeedType */
export var FeedType;
(function (FeedType) {
    FeedType[FeedType["None"] = 0] = "None";
    FeedType[FeedType["OnFeed"] = 1] = "OnFeed";
    FeedType[FeedType["Prospect"] = 2] = "Prospect";
    FeedType[FeedType["All"] = 3] = "All";
    FeedType[FeedType["ListHubListingKey"] = 8] = "ListHubListingKey";
    FeedType[FeedType["RentalHomesPlus"] = 9] = "RentalHomesPlus";
    FeedType[FeedType["WSRListingKey"] = 43] = "WSRListingKey";
})(FeedType || (FeedType = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["Unknown"] = 0] = "Unknown";
    ListingType[ListingType["Basic"] = 1] = "Basic";
    ListingType[ListingType["Silver"] = 2] = "Silver";
    ListingType[ListingType["Gold"] = 3] = "Gold";
    ListingType[ListingType["Platinum"] = 4] = "Platinum";
    ListingType[ListingType["Diamond"] = 5] = "Diamond";
    ListingType[ListingType["DiamondPlus"] = 6] = "DiamondPlus";
    ListingType[ListingType["SilverPlus"] = 7] = "SilverPlus";
    ListingType[ListingType["GoldPlus"] = 8] = "GoldPlus";
    ListingType[ListingType["PlatinumPlus"] = 9] = "PlatinumPlus";
})(ListingType || (ListingType = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.ListingStatusType */
export var ListingStatusType;
(function (ListingStatusType) {
    ListingStatusType[ListingStatusType["None"] = 0] = "None";
    ListingStatusType[ListingStatusType["Active"] = 1] = "Active";
    ListingStatusType[ListingStatusType["Pending"] = 2] = "Pending";
    ListingStatusType[ListingStatusType["OffMarket"] = 3] = "OffMarket";
    ListingStatusType[ListingStatusType["Terminate"] = 4] = "Terminate";
    ListingStatusType[ListingStatusType["SubscriptionHold"] = 5] = "SubscriptionHold";
    ListingStatusType[ListingStatusType["Unpublished"] = 6] = "Unpublished";
    ListingStatusType[ListingStatusType["AwaitingVerification"] = 7] = "AwaitingVerification";
    ListingStatusType[ListingStatusType["UserDeleted"] = 8] = "UserDeleted";
    ListingStatusType[ListingStatusType["Upsell"] = 9] = "Upsell";
})(ListingStatusType || (ListingStatusType = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.SortColumnType */
export var SortColumnType;
(function (SortColumnType) {
    SortColumnType[SortColumnType["None"] = 0] = "None";
    SortColumnType[SortColumnType["PropertyName"] = 1] = "PropertyName";
    SortColumnType[SortColumnType["PmcName"] = 2] = "PmcName";
    SortColumnType[SortColumnType["HasPhotos"] = 3] = "HasPhotos";
    SortColumnType[SortColumnType["ModelMapping"] = 4] = "ModelMapping";
    SortColumnType[SortColumnType["UnmatchedModels"] = 5] = "UnmatchedModels";
    SortColumnType[SortColumnType["Vendor"] = 6] = "Vendor";
    SortColumnType[SortColumnType["LastFeedUpdate"] = 7] = "LastFeedUpdate";
})(SortColumnType || (SortColumnType = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.ResidentialRentalBrokerageSortColumnType */
export var ResidentialRentalBrokerageSortColumnType;
(function (ResidentialRentalBrokerageSortColumnType) {
    ResidentialRentalBrokerageSortColumnType[ResidentialRentalBrokerageSortColumnType["None"] = 0] = "None";
    ResidentialRentalBrokerageSortColumnType[ResidentialRentalBrokerageSortColumnType["CompanyName"] = 1] = "CompanyName";
    ResidentialRentalBrokerageSortColumnType[ResidentialRentalBrokerageSortColumnType["City"] = 2] = "City";
    ResidentialRentalBrokerageSortColumnType[ResidentialRentalBrokerageSortColumnType["State"] = 3] = "State";
    ResidentialRentalBrokerageSortColumnType[ResidentialRentalBrokerageSortColumnType["FeedType"] = 4] = "FeedType";
    ResidentialRentalBrokerageSortColumnType[ResidentialRentalBrokerageSortColumnType["FeedName"] = 5] = "FeedName";
    ResidentialRentalBrokerageSortColumnType[ResidentialRentalBrokerageSortColumnType["PercentComplete"] = 6] = "PercentComplete";
    ResidentialRentalBrokerageSortColumnType[ResidentialRentalBrokerageSortColumnType["ListingId"] = 7] = "ListingId";
})(ResidentialRentalBrokerageSortColumnType || (ResidentialRentalBrokerageSortColumnType = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.ResidentialRentalSortColumnType */
export var ResidentialRentalSortColumnType;
(function (ResidentialRentalSortColumnType) {
    ResidentialRentalSortColumnType[ResidentialRentalSortColumnType["None"] = 0] = "None";
    ResidentialRentalSortColumnType[ResidentialRentalSortColumnType["ListingId"] = 1] = "ListingId";
    ResidentialRentalSortColumnType[ResidentialRentalSortColumnType["ListingStatus"] = 2] = "ListingStatus";
    ResidentialRentalSortColumnType[ResidentialRentalSortColumnType["PropertyId"] = 3] = "PropertyId";
    ResidentialRentalSortColumnType[ResidentialRentalSortColumnType["PropertyAddress"] = 4] = "PropertyAddress";
    ResidentialRentalSortColumnType[ResidentialRentalSortColumnType["Contact"] = 5] = "Contact";
    ResidentialRentalSortColumnType[ResidentialRentalSortColumnType["FeedType"] = 6] = "FeedType";
    ResidentialRentalSortColumnType[ResidentialRentalSortColumnType["Source"] = 7] = "Source";
    ResidentialRentalSortColumnType[ResidentialRentalSortColumnType["Date"] = 8] = "Date";
})(ResidentialRentalSortColumnType || (ResidentialRentalSortColumnType = {}));
/** CoStar.Api.AptsFeedManagement.ViewModels.ResidentialRentalStatusType */
export var ResidentialRentalStatusType;
(function (ResidentialRentalStatusType) {
    ResidentialRentalStatusType[ResidentialRentalStatusType["None"] = 0] = "None";
    ResidentialRentalStatusType[ResidentialRentalStatusType["Active"] = 1] = "Active";
    ResidentialRentalStatusType[ResidentialRentalStatusType["Inactive"] = 2] = "Inactive";
    ResidentialRentalStatusType[ResidentialRentalStatusType["All"] = 3] = "All";
})(ResidentialRentalStatusType || (ResidentialRentalStatusType = {}));
